import React from "react";
import Form from "../../common/form";
import ReactModal from "react-modal";
import schema from './mobileLogisticsPlanningCreateCompanySchema';

class MobileLogisticsPlanningCreateCompany extends Form {

    constructor() {
        super();
        this.setDataAndSchema();
    }

    baseInformation = schema;

    componentDidMount = async () => {

        const {showModal} = this.props;

        if (!showModal)
            return;

    };

    render = () => {
        const {
            showModal, style, ariaHideApp,
            companyTypeText
        } = this.props;
        const {
            data
        } = this.state;

        return (
            <React.Fragment>
                <ReactModal
                    isOpen={showModal}
                    contentLabel="MobileLogisticsPlanningCreateCompany"
                    style={style}
                    ariaHideApp={ariaHideApp}
                >
                    <h1>{companyTypeText + " anlegen"}</h1>

                    {this.renderCard(
                        "Daten",
                        [
                            {"name": "company.name"},
                            {"name": "company.firstname"},
                            {"name": "company.surname"},
                            {"name": "company.email"}
                        ]
                    )}
                    <div className="card">
                        <div className="card-body">
                            <div className="form-group row">
                                <div className="col-md-1">
                                    {this.renderSaveButton({})}
                                </div>
                                <div className="col-md-1">
                                    {this.renderCancelButton({})}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*</form>*/}
                </ReactModal>
            </React.Fragment>
        );
    }
}

export default MobileLogisticsPlanningCreateCompany;
